/* eslint-disable no-loop-func */
const dateUtil = require('../../../utils/dateUtil/dateUtil.js');
const translator = require('../../../utils/translator/translator');

export default function RotaViewTableHeader(props)
{

    const screenWidth = window.innerWidth;
    const minWidth = screenWidth / 8.14;

    var tableHeaderRowComponents = [];
    tableHeaderRowComponents.push(<th style={{ width: minWidth, fontWeight:'normal', zIndex: 999, top: 'auto', left: 0, background: '#FFFFFF', position: 'sticky', textAlign: 'center', verticalAlign: 'middle', borderBottom: '1px solid #CBCBCB' }}>{translator.getLabel("staff")}</th>);

    props.rotaDates.forEach((date) => 
    {
        var localDate = dateUtil.convertToLocalStandard(date);

        var captionComponent = <div><div>{dateUtil.formatDate(localDate, "ddd")}</div><div>{dateUtil.formatDate(localDate, "DD/MMM")}</div></div>
        tableHeaderRowComponents.push(<th style={{ minWidth: minWidth, fontWeight:'normal', textAlign: 'center', verticalAlign: 'center', borderBottom: '1px solid #CBCBCB' }}>{captionComponent}</th>);
    })

    return <tr>
        {tableHeaderRowComponents}
    </tr>

}